module.exports = __webpack_public_path__ + "static/media/motor.6d7cb51a.png";